import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-brand-cream px-4 py-7" data-id="element-33" data-mp="1hd1oa0f9lc0k">
      <div className="mx-auto max-w-2xl" data-id="element-34" data-mp="1hbgsy8l4lp1n">
        <h2 className="text-center font-display text-xl font-extrabold uppercase leading-tight text-brand-navy sm:text-2xl" data-id="element-35" data-mp="1cf041c63r6ni">
          Domande frequenti
        </h2>

        <dl className="mt-4 space-y-2" data-id="element-36" data-mp="29zw6srsiu1be">
          {faqs.map((faq, i) => {
          const open = openIndex === i;
          return <div key={faq.q} className="overflow-hidden rounded-lg border-2 border-brand-navy/15 bg-white" data-id="element-37" data-mp="2039krzogl47s" data-mpi={i}>
                <dt data-id="element-38" data-mp="1v7c4ftd73xv0">
                  <button type="button" onClick={() => setOpenIndex(open ? null : i)} aria-expanded={open} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-3 px-3.5 py-3 text-left transition-colors duration-150 ease-out hover:bg-brand-cream" data-id="element-39" data-mp="oonr1mw02jq2">
                    <span className="text-sm font-extrabold leading-snug text-brand-navy" data-id="element-40" data-mp="1apsuguj3zl9t">
                      {faq.q}
                    </span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-green transition-transform duration-200 ease-out ${open ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-41" data-mp="1fn2ge07ahesw" />
                  </button>
                </dt>
                {open && <dd id={`faq-${i}`} className="space-y-1.5 px-3.5 pb-3 text-sm font-medium leading-snug text-brand-graphite" data-id="element-42" data-mp="rwyebx9r1n40">
                    {faq.a.map(line => <p key={line} data-id="element-43" data-mp="mzq54m6kwtew">{line}</p>)}
                  </dd>}
              </div>;
        })}
        </dl>
      </div>
    </section>;
}